import * as React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FurtherConsiderationsEntryStore } from '../../stores/further-considerations-entry-store';
import { RootCauseCategory } from '../../models/RootCauseCategory';
import { FurtherConsiderations } from '../../models/FurtherConsiderations';

type State = {
  showTerms: boolean;
};

interface TermsModalProps {
  furtherConsiderationsEntryStore: FurtherConsiderationsEntryStore;
}

export class TermsModal extends React.Component<TermsModalProps, {}> {
  state: State  = {
    showTerms: false
  };

  termsAndConditions: FurtherConsiderations;

  async componentDidMount() {
    const showTerms = await this.showTerms();
    this.setState({
      showTerms
    });
  }

  async showTerms(): Promise<boolean> {
    const hasAcceptedLabsmartzTerms = await localStorage.getItem('hasAcceptedLabsmartzTerms');
    if (hasAcceptedLabsmartzTerms !== 'true') {
      this.termsAndConditions = await this.props.furtherConsiderationsEntryStore.loadFurtherConsiderations();
    }
    return hasAcceptedLabsmartzTerms !== 'true';
  }

  acceptTerms = (): void => {
    localStorage.setItem('hasAcceptedLabsmartzTerms', 'true');
    this.setState({
      showTerms: false
    });
  }

  furtherConsiderationsFor(rootCauseCategory: RootCauseCategory): JSX.Element {
    return (
      <span key={rootCauseCategory}>
        {
          this.termsAndConditions.findConsiderations(rootCauseCategory).map((consideration, cindex) => {
            return (
              <span key={cindex}>
                <span key={`title-${cindex}`} className="consideration-title">
                  {consideration.title}
                </span>
                {
                  consideration.items.map((item, itemIndex) => {
                    return <p key={`${rootCauseCategory}-${cindex}-${itemIndex}`}>{item}</p>;
                  })
                }
              </span>
            );
          })
        }
      </span>
    );  
}

  render() {
    console.log('TermsModal is rendering....');
    if (!this.state.showTerms) {
      return null;
    }

    return (
      <Modal show={this.state.showTerms} onHide={this.acceptTerms} backdrop="static">
        <Modal.Header style={{ backgroundColor: '#337ab7', color: '#fff' }}>
          <Modal.Title>Terms of Use</Modal.Title>
        </Modal.Header>
        {/* style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}} */}
        <Modal.Body>
          {this.furtherConsiderationsFor(RootCauseCategory.CATEGORY_998)}
        </Modal.Body>
        <Modal.Footer>
          By selecting the Agree button, you agree to the Terms of Use.&nbsp;&nbsp;
          <Button onClick={this.acceptTerms}>Agree</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
